// internal
import { axios, def, storage, setClientFilter, saveFilterList, handleResponse, handleError } from './internal';

// storage
import { getFilterRecord } from '../storage/indexeddb';

async function FilterRecommendList(onSuccess, setData) {
    setData?.((prev) => ({ ...prev, loading: true }));

    const cached = await getFilterRecord('recommend');
    const filterHash = cached.filters.meta?.hash ?? '';
    const filterOptionsHash = cached.filterOptions.meta?.hash ?? '';

    axios
        .get('/api/filters/recommend', { params: { filterHash, filterOptionsHash } })
        .then(async (res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK: {
                    const filters = await saveFilterList('recommend', res.data.data);
                    storage.transience.setState('filter.recommend.data', filters);
                    setClientFilter('recommend', filters);
                    onSuccess?.(filters);
                    break;
                }
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => setData?.((prev) => ({ ...prev, loading: false })));
}

export { FilterRecommendList };
